{
  "ACTIVITEITEN": {
    "ACTIEPUNTEN": {
      "BUTTON": {
        "SLUITEN": "Sluiten"
      },
      "EXPORTNAAM": "Actiepunten",
      "GRID": {
        "DATUM": "Datum",
        "DATUM_GEREED": "Datum gereed",
        "DATUM_GEWENST": "Datum gewenst",
        "JAAR": "Jaar",
        "KENBRI_ORDER": "Kenbri order",
        "KLACHTOMSCHRIJVING": "Klachtomschrijving",
        "OBJECT": "Object",
        "STATUS_OBJECT": "Status object",
        "STATUS_ORDER": "Status order",
        "UITVOERENDE": "Uitvoerende",
        "VOORTGANG_EINDRESULTAAT": "Voortgang/eindresultaat"
      },
      "INFO_DETAIL": "Klik op een rij om de details te zien",
      "POPUP": {
        "DATUM": "Datum",
        "DATUMGEREED": "Datum gereed",
        "DATUMGEWENST": "Datum gewenst",
        "KENBRI_ORDER": "Kenbri order",
        "KLACHTOMSCHRIJVING": "Klachtomschrijving",
        "OBJECT": "Object",
        "STATUS_OBJECT": "Status object",
        "TITEL": "Details",
        "UITVOERENDE": "Uitvoerende",
        "VOORTGANG_EINDRESULTAAT": "Voortgang/eindresultaat"
      },
      "TITEL": "CORRECTIEVE ACTIEPUNTEN",
      "TOON": "Toon",
      "VIEWS": {
        "ALLES": "Alles",
        "UITGEVOERD": "Uitgevoerd",
        "UITVOEREN": "Uitvoeren"
      }
    },
    "KENBRI": {
      "BUTTON": {
        "FILTER_WISSEN": "Filter wissen",
        "ZOEKEN": "Zoeken"
      },
      "DETAIL": {
        "BUTTON": {
          "FILTER_WISSEN": "Filter wissen",
          "RAPPORT_WEERGEVEN": "Rapport weergeven",
          "TERUG": "Terug naar overzicht",
          "TOON_ALLEEN_AFWIJKINGEN": "Toon alleen afwijkingen"
        },
        "CONTACTPERSOON": "Contactpersoon",
        "GEPLAND": "Gepland",
        "LOCATIE_WERKZAAMHEDEN": "Locatie werkzaamheden",
        "MELDING": {
          "ACTIVITEIT_NIET_GELADEN": "De activiteit kan niet worden geladen, neem contact op met de beheerder"
        },
        "MELDINGEN": {
          "FOTO_NIET_LADEN": "Foto kan niet worden geladen",
          "RESULTATEN_NIET_LADEN": "De resultaten kunnen niet worden geladen, neem contact op met de beheerder"
        },
        "NUMMER": "Nummer",
        "OMSCHRIJVING": "Omschrijving",
        "POPUP": {
          "WERKCODES": {
            "GRID": {
              "NAAM": "Naam",
              "OPMERKING": "Opmerking",
              "STATUS": "Status"
            },
            "TITEL": "Werkcodes"
          }
        },
        "REFERENTIE": "Referentie",
        "TABS": {
          "DOCUMENTEN": {
            "TITEL": "Documenten"
          },
          "MATERIALEN": {
            "TITEL": "Materialen"
          },
          "RESULTATEN": {
            "CORRECTIEF": {
              "ACTIEPUNTEN": {
                "GRID": {
                  "DATUM_GEREED": "Datum gereed",
                  "DATUM_GEWENST": "Datum gewenst",
                  "GEREED": "Gereed",
                  "OMSCHRIJVING": "Omschrijving",
                  "PRIORITEIT": "Prioriteit",
                  "RESULTAAT": "Resultaat",
                  "SERVICE_APPARATUUR": "Service apparatuur",
                  "UITVOERENDE": "Uitvoerende",
                  "VERANTWOORDELIJKE": "Verantwoordelijke",
                  "VERVOLG_ACTIES": "Vervolg acties"
                },
                "TITEL": "Actiepunten"
              },
              "KLACHT": "Klacht",
              "MATERIALEN": {
                "GRID": {
                  "AANTAL": "Aantal",
                  "ARTIKEL_NUMMER": "Artikelnummer",
                  "ARTIKEL_OMSCHRIJVING": "Artikelomschrijving"
                },
                "TITEL": "Gebruikte materialen"
              },
              "OPMERKING": "Opmerking",
              "STATUS": "Status",
              "TITEL": "Correctief",
              "VERVOLG_ACTIES": "Vervolgactie(s) nodig",
              "WERKCODES": {
                "GRID": {
                  "NAAM": "Naam",
                  "OPMERKING": "Opmerking",
                  "STATUS": "Status"
                },
                "TITEL": "Gekoppelde werkcodes"
              }
            },
            "GRID": {
              "BEDRIJFSUREN": "Bedrijfsuren",
              "FABRIKANT": "Fabrikant",
              "HATZGENERATOR": "Hatzgenerator",
              "KILOMETERSTAND": "Kilometerstand",
              "NAAM": "Naam",
              "PRODUCTGROEP": "Productgroep",
              "STATUS": "Status",
              "TYPE": "Type"
            },
            "PREVENTIEF": {
              "AANTAL_WERKCODES": "#Werkcodes",
              "TITEL": "Preventief",
              "VRAAG": "Vraag",
              "VRAGENBLOK": "Vragenblok"
            },
            "TITEL": "Resultaten"
          }
        },
        "TITEL": "Detail",
        "UITGEVOERD": "Uitgevoerd",
        "WERKZAAMHEDEN": "Werkzaamheden"
      },
      "GRID": {
        "AANTAL_ITEMS": "#Aantal",
        "ACTIVITEIT_WEERGEVEN": "Activiteit weergeven",
        "CONTACTPERSOON": "Contactpersoon",
        "DETAIL": {
          "OBJECTEN": {
            "GRID": {
              "ACTIVITEIT_WEERGEVEN": "Activiteit weergeven",
              "FABRIKANT": "Fabrikant",
              "KLACHT": "Klacht",
              "NAAM": "Naam",
              "OPENSTAANDE_ACTIEPUNTEN": "#Openstaande actiepunten",
              "PRODUCTGROEP": "Productgroep",
              "STATUS": "Status",
              "TYPE": "Type"
            },
            "MELDING": {
              "NIET_GELADEN": "De objecten kunnen niet worden geladen, neem contact op met de beheerder"
            },
            "TITEL": "Objecten"
          },
          "RAPPORTEN": {
            "GRID": {
              "RAPPORT": "Rapport",
              "TITEL": "BESCHIKBARE RAPPORTEN"
            },
            "MELDING": {
              "NIET_GELADEN": "De beschikbare rapporten kunnen niet worden geladen, neem contact op met de beheerder"
            },
            "TITEL": "Rapporten"
          }
        },
        "EERSTE_OBJECT": "Eerste object",
        "EXPORT": {
          "BESTANDSNAAM": "Activiteiten"
        },
        "GEPLAND": "Gepland",
        "KENBRI_REFERENTIE": "Kenbri referentie",
        "OMSCHRIJVING": "Omschrijving",
        "ONZE_REFERENTIE": "Onze referentie",
        "PDF_RAPPORT_WEERGEVEN": "PDF rapport weergeven",
        "RAPPORT_AANMAKEN_EN_WEERGEVEN": "Rapport genereren en weergeven",
        "STATUS": "Status",
        "UITGEVOERD": "Uitgevoerd",
        "UITGEVOERD_DOOR": "Uitgevoerd door",
        "WERKZAAMHEDEN": "Werkzaamheden"
      },
      "LEGENDA": {
        "INGEPLAND": "Ingepland",
        "IN_UITVOERING": "In uitvoering",
        "TE_PLANNEN": "Te plannen",
        "TITEL": "Legenda",
        "UITGEVOERD": "Uitgevoerd"
      },
      "MELDING": {
        "KAN_NIET_LADEN": "De activiteiten kunnen niet worden geladen, neem contact op met de beheerder"
      },
      "RAPPORT": {
        "MELDING": {
          "AANGEMAAKT": "Het rapport met {{objectenAantal}} wordt momenteel opgehaald, bij veel objecten kan dit tot enkele minuten duren...",
          "OBJECT": "object",
          "OBJECTEN": "objecten",
          "OPGEHAALD_CLOUD": "Het pdf rapport wordt opgehaald uit de cloud..."
        },
        "TITEL": "Activiteit rapport - {{title}}"
      },
      "TITEL": "OVERZICHT KENBRI ACTIVITEITEN",
      "ZOEKEN_OP_KLACHT": "Zoeken op klacht"
    },
    "KLANT": {
      "BUTTON": {
        "PLAN_RONDEN": "Plan alle ronden"
      },
      "DETAIL": {
        "BUTTON": {
          "TERUG_OVERZICHT": "Terug naar het overzicht"
        },
        "GEPLAND": "Gepland",
        "GRID": {
          "BUTTON": {
            "OPSLAAN": "Opslaan"
          },
          "FABRIKANT": "Fabrikant",
          "NAAM": "Naam",
          "NIET_UITVOEREN": "Niet uitvoeren",
          "OPVOLGING": "Opvolging",
          "PRODUCTGROEP": "Productgroep",
          "STATUS": "Status",
          "TYPE": "Type",
          "UITGEVOERD_DOOR": "Uitgevoerd door",
          "UITGEVOERD_OP": "Uitgevoerd op",
          "VRAAG": "Vraag",
          "VRAGENBLOK": "Vragenblok"
        },
        "MELDING": {
          "ACTIVITEIT_NIET_GELADEN": "De activiteit kan niet worden geladen, neem contact op met de beheerder",
          "ANTWOORD_NIET_VERWERKT": "Het antwoord is niet verwerkt!",
          "ANTWOORD_VERWERKT": "Het antwoord is succesvol verwerkt",
          "FOTO_NIET_LADEN": "Foto kan niet worden geladen, neem contact op met de beheerder",
          "KAN_NIET_VERVERSEN": "De activiteit kan niet worden ververst, neem contact op met de beheerder",
          "NIET_VERWERKT": "De gegevens zijn niet succesvol verwerkt!",
          "RESULTATEN_NIET_LADEN": "De resultaten kunnen niet worden geladen, neem contact op met de beheerder",
          "STATUSLIJST_NIET_GELADEN": "De status lijst kan niet worden geladen, neem contact op met de beheerder",
          "VERWERKT": "De gegevens zijn succesvol verwerkt"
        },
        "NAAM": "Naam",
        "OPMERKING": "Opmerking",
        "POPUP": {
          "BUTTON": {
            "ANNULEREN": "Annuleren",
            "OPSLAAN": "Opmerking opslaan"
          },
          "OPMERKING": "Opmerking"
        },
        "RESULTATEN": "Resultaten",
        "TITEL": "Detail",
        "UITGEVOERD": "Uitgevoerd"
      },
      "GRID": {
        "ACTIVITEIT_WEERGEVEN": "Activiteit weergeven",
        "DATUM_GEPLAND": "Gepland",
        "DATUM_GEREED": "Gereed",
        "EXPORT": {
          "BESTANDSNAAM": "Activiteiten"
        },
        "NAAM": "Naam",
        "OPMERKING": "Opmerking"
      },
      "MELDING": {
        "AANGEMAAKT": "De activiteiten zijn succesvol aangemaakt",
        "NIET_AANGEMAAKT": "De activiteiten kunnen niet worden aangemaakt",
        "NIET_GELADEN": "De activiteiten kunnen niet worden geladen, neem contact op met de beheerder",
        "NIET_VERWIJDERD": "De activiteit kan niet worden verwijderd",
        "SELECTEER_RECORD": "Selecteer eerst 1 of meerdere records"
      },
      "TITEL": "overzicht eigen activititeiten",
      "VRAAG": {
        "VERWIJDEREN": "Weet je zeker dat je de niet uitgevoerde activiteiten wilt verwijderen?"
      }
    },
    "PERIODE_OVERZICHT": {
      "BUTTON": {
        "RAPPORT_AANMAKEN": "Rapport aanmaken"
      },
      "GRID": {
        "AANTAL_ACTIEPUNTEN": "#Actiepunten",
        "AANTAL_ACTIEPUNTEN_GEREED": "#Actiepunten gereed",
        "AANTAL_ITEMS": "#Items",
        "AANTAL_OPENSTAANDE_ACTIEPUNTEN": "#Actiepunten openstaand",
        "ACTIVITEIT_WEERGEVEN": "Activiteit weergeven",
        "CONTACTPERSOON": "Contactpersoon",
        "DATUM_GEPLAND": "Datum gepland",
        "DATUM_UITGEVOERD": "Datum uitgevoerd",
        "DETAIL": {
          "AFWIJKENDE_OBJECTEN": {
            "TITEL": "Afwijkende objecten"
          },
          "OBJECTEN": {
            "FABRIKANT": "Fabrikant",
            "NAAM": "Naam",
            "PRODUCTGROEP": "Productgroep",
            "STATUS": "Status",
            "TYPE": "Type"
          },
          "OPENSTAANDE_ACTIEPUNTEN": {
            "GRID": {
              "DATUM_GEREED": "Datum gereed",
              "DATUM_GEWENST": "Datum gewenst",
              "GEREED": "Gereed",
              "OBJECT": "Object",
              "PRIORITEIT": "Prioriteit",
              "RESULTAAT": "Resultaat",
              "SERVICE_APPARATUUR": "Service apparatuur",
              "UITVOERENDE": "Uitvoerende",
              "VERVOLG_ACTIES": "Vervolg acties",
              "VERWANTWOORDELIJKE": "Verantwoordelijke"
            },
            "TITEL": "Openstaande actiepunten"
          }
        },
        "EERSTE_OBJECT": "Eerste object",
        "KENBRI_REFERENTIE": "Kenbri referentie",
        "OMSCHRIJVING": "Omschrijving",
        "ONZE_REFERENTIE": "Onze referentie",
        "PDF_RAPPORT_WEERGEVEN": "PDF rapport weergeven",
        "RAPPORT_AANMAKEN_WEERGEVEN": "Rapport genereren en weergeven",
        "STATUS": "Status",
        "UITGEVOERD_DOOR": "Uitgevoerd door",
        "WERKZAAMHEDEN": "Werkzaamheden"
      },
      "HEADER_TEKST": "Overzicht activiteiten {{startDate}} tot en met {{endDate}}",
      "LEGENDA": {
        "INGEPLAND": "Ingepland",
        "IN_UITVOERING": "In uitvoering",
        "TE_PLANNEN": "Te plannen",
        "UITGEVOERD": "Uitgevoerd"
      },
      "MELDING": {
        "STATUS_LIJST_NIET_GELADEN": "De status lijst kan niet worden geladen, neem contact op met de beheerder"
      },
      "PERIODE": "Periode",
      "TITEL": "Periode overzicht",
      "TOTAAL": "Totaal"
    }
  },
  "ALGEMEEN": {
    "ANNULEREN": "Annuleren",
    "EVEN_GEDULD": "Even geduld",
    "FOUT": {
      "GEGEVENS_NIET_GELADEN": "De records kunnen niet worden geladen, neem contact op met de beheerder",
      "KAN_GEGEVENS_NIET_LADEN": "De gegevens kunnen niet worden geladen, neem contact op met de beheerder",
      "KAN_KLANT_STATISTIEKEN_NIET_LADEN": "De statistieken voor de klant activiteiten kunnen niet worden geladen, neem contact op met de beheerder",
      "TEKST": "Er is is mis fout gegaan, neem contact op met de beheerder.",
      "TITEL": "Fout"
    },
    "GEEN_VERTALING": "Vertaling niet gevonden: {{tag}}",
    "GELUKT": "Gelukt",
    "JA": "Ja",
    "KAN_VERSIE_NIET_OPHALEN": "Kan het versienummer niet ophalen",
    "KIES_TAAL": "Kies je taal/Choose your language/Wählen Sie Ihre Sprache",
    "LETOP": "Let op",
    "LICENTIE_ACTIEF": "Licentie actief",
    "LICENTIE_VERLOPEN": "Licentie verlopen",
    "MISLUKT": "Mislukt",
    "NEE": "Nee",
    "OPSLAAN": "Opslaan",
    "RAPPORT_WORDT_OPGEHAALD": "Het rapport wordt opgehaald...",
    "TAALKEUZE_VERPLICHT": "Je moet een taal kiezen",
    "TAAL_GEWIJZIGD": "De taal is succesvol aangepast",
    "TAAL_NIET_GEWIJZIGD": "De taal is niet gewijzigd",
    "WAARSCHUWING": "Waarschuwing",
    "ZEKER_WETEN": "Zeker weten?"
  },
  "BEHEER": {
    "GEBRUIKERS": {
      "GRID": {
        "AANGEMAAKT_OP": "Aangemaakt op",
        "AANTAL_ROLLEN": "#Rollen",
        "BESCHIKBARE_KLANTEN": "Beschikbare klanten voor {{userName}}",
        "BUTTON": {
          "KOPPEL": "Koppel geselecteerde klanten",
          "ONTKOPPEL": "Ontkoppel geselecteerde klanten"
        },
        "EMAIL": "Email",
        "GEBLOKKEERD": "Geblokkeerd",
        "GEBLOKKEERD_TOT": "Geblokkeerd tot",
        "GEBRUIKERSNAAM": "Gebruikersnaam",
        "GEKOPPELDE_KLANTEN": "Klanten gekoppeld aan {{userName}}",
        "HERHAAL_WACHTWOORD": "Herhaal wachtwoord",
        "KLANT": "Klant",
        "LAATST_INGELOGD": "Laatst ingelogd",
        "LOGIN_ALS": "Inloggen als deze gebruiker",
        "ROL": "Rol",
        "UITSLUITEN": "Uitsluiten",
        "WACHTWOORD": "Wachtwoord",
        "WACHTWOORD_KOMT_NIET_OVEREEN": "De wachtwoorden komen niet overeen"
      },
      "MELDING": {
        "KLANTEN_ZIJN": "Klanten zijn",
        "KLANT_IS": "Klant is",
        "LOGIN_ALS": {
          "TEKST": "Wil je inloggen als de gebruiker {{username}}?",
          "TITEL": "Inloggen?"
        },
        "NIET_GEKOPPELD": "niet gekoppeld",
        "NIET_GELADEN": "De gebruikers kunnen niet worden geladen: {{msg}}",
        "NIET_GEWIJZIGD": "De gebruiker kan niet worden gewijzigd: {{msg}}",
        "NIET_ONTKOPPELD": "niet ontkoppeld",
        "NIET_TOEGEVOEGD": "De gebruiker kan niet worden toegevoegd: {{msg}}",
        "NIET_VERWIJDERD": "De gebruiker kan niet worden verwijderd: {{msg}}",
        "ROL_GEWIJZIGD": "Rol is succesvol gewijzigd'",
        "ROL_NIET_GEWIJZIGD": "Rol is niet succesvol gewijzigd",
        "ROL_NIET_VERWIJDERD": "Rol is niet succesvol verwijderd",
        "ROL_VERWIJDERD": "Rol is succesvol verwijderd",
        "SELECTEER_KLANT": "Selecteer minimaal één klant",
        "SUCCESVOL_GEKOPPELD": "succesvol gekoppeld",
        "SUCCESVOL_ONTKOPPELD": "succesvol ontkoppeld"
      },
      "MFA": {
        "RESET": {
          "CONFIRM": {
            "TEKST": "Weet je zeker dat je MFA opnieuw wilt instellen voor {{username}}?",
            "TITEL": "Onieuw instellen MFA"
          },
          "FOUT": "Het opnieuw instellen van MFA voor {{username}} is mislukt: {{error}}",
          "SUCCES": "MFA is opnieuw gesteld voor {{username}}"
        }
      },
      "TITEL": "Gebruikers"
    }
  },
  "CONTACTGEGEVENS": {
    "TITEL": "Contactgegevens"
  },
  "DASHBOARD": {
    "KENBRI_ACTIEPUNTEN": {
      "TITEL": "Kenbri actiepunten correctief",
      "UITGEVOERD": "Uitgevoerd",
      "UITVOEREN": "Uitvoeren"
    },
    "KENBRI_ACTIVITEITEN": {
      "INGEPLAND": "Ingepland",
      "IN_UITVOERING": "In uitvoering",
      "TE_PLANNEN": "Te plannen",
      "TITEL": "Kenbri activiteiten",
      "UITGEVOERD": "Uitgevoerd"
    },
    "KENBRI_KPI": {
      "CHART_TITEL": "Kenbri activiteiten",
      "TITEL": "Kenbri KPI's"
    },
    "NIEUWS": {
      "TITEL": "NIEUWSBERICHTEN"
    },
    "OBJECTEN": {
      "KENBRI_ADVIES": "Kenbri adviseert om actie te ondernemen bij afwijkingen binnen het volgende tijdspad",
      "TITEL": "OBJECTEN",
      "TOTAAL_AANTAL": "Totaal aantal objecten"
    },
    "STATUS_OBJECTEN": {
      "TITEL": "Status overzicht objecten"
    }
  },
  "DOCUMENTEN": {
    "ALGEMEEN": {
      "BESTAND_GEUPLOAD": "Bestand {{fileName}} is geupload!",
      "BESTAND_NIET_GEUPLOAD": "Bestand {{fileName}} is niet geupload!",
      "DETAIL": {
        "TITEL": "Bewerken document"
      },
      "FOTO_FOUT_TEKST": "De foto kan niet worden weergegeven, neem contact op met de beheerder",
      "FOUT_NIET_GEWIJZIGD": "Het document kan niet worden gewijzigd",
      "FOUT_NIET_VERWIJDERD": "Het document kan niet worden verwijderd",
      "FOUT_TEKST": "De documenten kunnen niet worden geladen, neem contact op met de beheerder",
      "FOUT_TITEL": "Fout",
      "GELUKT": "Gelukt!",
      "GRID": {
        "AANGEMAAKTOP": "Aangemaakt op",
        "DOCUMENTSOORT": "Documentsoort",
        "GROOTTE": "Grootte",
        "LAATSTGEWIJZIGDOP": "Laatst gewijzigd op",
        "NAAM": "Naam",
        "OPMERKINGEN": "Opmerkingen"
      }
    },
    "OBJECT": {
      "GRID": {
        "AANGEMAAKTOP": "Aangemaakt op ",
        "DOCUMENTSOORT": "Documentsoort",
        "GROOTTE": "Grootte",
        "LAATSTGEWIJZIGDOP": "Laatst gewijzigd op",
        "NAAM": "Documentnaam",
        "OBJECT": "Object",
        "OPMERKINGEN": "Opmerkingen",
        "RAPPORT_FOTO": "Rapport foto"
      },
      "TITEL": "Documenten"
    },
    "RAPPORTAGE": {
      "GRID": {
        "AANGEMAAKTOP": "Aangemaakt op",
        "DOCUMENTSOORT": "Documentsoort",
        "GROOTTE": "Grootte",
        "LAATSTGEWIJZIGDOP": "Laatst gewijzigd op",
        "NAAM": "Naam",
        "OPMERKINGEN": "Opmerkingen"
      },
      "TITEL": "Rapportage"
    },
    "TITEL": "Documenten",
    "UPLOAD_DOCUMENT": "Document uploaden"
  },
  "FEEDBACK": {
    "FORMULIER": {
      "BERICHT": {
        "LABEL": "Omschrijving",
        "PLACEHOLDER": "Wat gaat er fout?"
      },
      "BUTTON": {
        "ANNULEREN": "Annuleren",
        "BEVESTIGEN": "Bevestigen",
        "SCHERMAFBEELDING": {
          "TOEVOEGEN": "Schermafbeelding verwijderen",
          "VERWIJDEREN": "Schermafbeelding toevoegen"
        },
        "VERSTUREN": "Versturen"
      },
      "EMAIL": {
        "LABEL": "Je emailadres",
        "PLACEHOLDER": "Email"
      },
      "NAAM": {
        "LABEL": "Naam",
        "PLACEHOLDER": "Je naam"
      },
      "SUCCESBERICHT": "Bedankt voor je melding!",
      "TITEL": "Een fout melden",
      "VELD_VERPLICHT": "(verplicht)"
    },
    "LABEL": "Een fout melden"
  },
  "GEBRUIKERMENU": {
    "LOGO_UPLOADEN": "Logo uploaden",
    "MFA_RESET": "MFA opnieuw instellen",
    "MFA_RESET_BUTTON_CANCEL": "Annuleren",
    "MFA_RESET_BUTTON_CONFIRM": "Bevestigen",
    "MFA_RESET_GELUKT": "Multi-Factor Authenticatie is opnieuw ingesteld. Bij je volgende aanmelding wordt je gevraagd MFA opnieuw in te stellen.",
    "MFA_RESET_GELUKT_TITLE": "MFA opnieuw instellen",
    "MFA_RESET_MISLUKT": "Er is een fout opgetreden bij het opnieuw instellen van je Multi-Factor Authenticatie. Neem contact op met Kenbri.",
    "MFA_RESET_QUESTION": "Weet u zeker dat je de Multi-Factor Authenticatie opnieuw wilt instellen?",
    "MFA_RESET_REQUIRE_PASSWORD": "Voer uw wachtwoord in ter bevestiging:",
    "TAAL_WIJZIGEN": "Taal instellen",
    "UITLOGGEN": "Uitloggen",
    "WACHTWOORD_WIJZIGEN": "Wachtwoord wijzigen"
  },
  "GEBRUIKTE_MATERIALEN": {
    "GRID": {
      "AANTAL": "Aantal",
      "ARTIKELNUMMER": "Artikelnummer",
      "ARTIKELOMSCHRIJVING": "Artikelomschrijving",
      "NAAM": "Naam",
      "OPMERKING": "Opmerking",
      "STATUS": "Status"
    }
  },
  "HELP": {
    "FAQ": {
      "FORMULIER": {
        "BERICHT_OF_VRAAG": "Uw bericht of vraag",
        "KNOP_VERSTUREN": "VersturenUw vraag is niet succesvol ontvangen wegens een technische fout",
        "ONDERWERP": "Onderwerp",
        "ONDERWERP_VERPLICHT": "Vul een onderwerp in ",
        "TEKST": "Staat uw vraag er niet bij? Neem dan contact met ons op via het onderstaande formulier, wij doen ons best om uw vraag zo snel mogelijk te beantwoorden.",
        "TEKST_VERPLICHT": "De velden gemarkeerd met een<span class=\"dx-field-item-required-mark\">&nbsp;*</span> zijn verplicht.",
        "TITEL": "Contact",
        "VRAAG_NIET_VERSTUURD": "Uw vraag is niet succesvol ontvangen wegens een technische fout",
        "VRAAG_VERPLICHT": "Vul een bericht of vraag in",
        "VRAAG_VERSTUURD": "Uw vraag is succesvol ontvangen"
      },
      "TITEL": "Veelgestelde vragen"
    }
  },
  "INFO": {
    "GEPLANDE_WIJZIGINGEN": {
      "TITEL": "Geplande wijzigingen voor",
      "VERSIE": "Versie"
    },
    "LICENTIE": {
      "AANTAL_DOSSIERS": "<strong>Onbeperkt</strong> aantal dossiers",
      "AANTAL_GEBRUIKERS": "<strong>Onbeperkt</strong> aantal objecten",
      "AANTAL_OBJECTEN": "<strong>Onbeperkt</strong>  aantal gebruikers",
      "ACTIVITEIT_TOEVOEGEN": "Activiteiten toevoegen",
      "DAG": "dag",
      "DAGEN": "dagen",
      "INRICHTINGSKOSTEN": "Inrichtingskosten op nacalculatie",
      "ISACTIEF": "Licentie is actief",
      "KOPPELEN_DOCUMENTEN": "Koppelen van documenten",
      "NOG": "nog",
      "OBJECTEN_TOEVOEGEN": "Objecten toevoegen",
      "RESTEREND": "resterend",
      "SERVICEKALENDER": "Servicekalender",
      "SEVESO_DASHBOARD": "Dashboard met voortgang van het dossier",
      "TITEL": "Uw licentie",
      "TOT": "tot"
    },
    "NIEUWS": {
      "GEEN_NIEUWS": "Er zijn op dit moment geen nieuwsberichten.",
      "NIEUWS_BLIJFT_ZIEN_TOT": "Nieuwsbericht is zichtbaar tot en met: "
    },
    "VERSIE_OVERZICHT": {
      "VERSIE": "Versie"
    }
  },
  "KLANTLOGO": {
    "POPUP": {
      "BUTTON_UPLOAD": "Nieuw logo uploaden",
      "GEEN_LOGO": "Er is nog geen logo geupload, klik op onderstaande knop om een logo te uploaden",
      "TITEL": "Klant logo wijzigen"
    }
  },
  "LICENTIE": {
    "BIJNA_VERLOPEN": {
      "TEKST": "<p>De licentie van {{customerName}} verloopt over {{numberOfDays}} {{dayLabel}}. Daarna kunt u het portaal niet meer openen. </p><p>Neem contact op met Kenbri via +31(0)187493588 om uw licentie te verlengen.</p>",
      "TITEL": "Let op: de licentie is bijna verlopen"
    },
    "VERLOPEN": {
      "TEKST": "De licentie van {{customerName}} is verlopen, neem contact op met Kenbri via +31(0)187493588 om de licentie te verlengen.",
      "TITEL": "De licentie is verlopen"
    }
  },
  "LOGIN": {
    "BUTTON": {
      "INLOGGEN": "Inloggen"
    },
    "FOUTMELDING": "Foutmelding",
    "GEBRUIKERSNAAM": "Gebruikersnaam",
    "LOGIN_HINT": "Log in met je gebruikersnaam en wachtwoord",
    "MELDING": {
      "GEBRUIKERSNAAM_VERPLICHT": "Gebruikersnaam is verplicht",
      "ONDERHOUD": "Wegens onderhoud is TotalCare tijdelijk niet beschikbaar.",
      "SESSIE_VERLOPEN": {
        "TEKST": "De sessie is verlopen, je moet opnieuw inloggen.",
        "TITEL": "Sessie is verlopen"
      },
      "TECHNISCHE_FOUT": "Er is een technisch probleem opgetreden, probeer het nogmaals of neem contact op met de beheerder",
      "WACHTWOORD_VERPLICHT": "Wachtwoord is verplicht"
    },
    "MFA": {
      "CODE_INVOEREN": "Voer de code uit de authenticator app in:",
      "FOUTMELDING": "Inloggen niet mogelijk",
      "GEEN_TOEGANG": "Ik heb geen toegang tot mijn authenticatie-app",
      "HERSTELCODE_INVOEREN": "Vul één van je herstelcodes in te loggen",
      "TERUG_NAAR_CODE": "Terug naar invoer code",
      "VALIDEREN": "Valideren..."
    },
    "TITEL": "Inloggen TotalCare portal {{environmentName}}",
    "WACHTWOORD": "Wachtwoord",
    "WACHTWOORD_VERGETEN": "Wachtwoord vergeten?"
  },
  "MENU": {
    "ACTIVITEITEN": {
      "ACTIEPUNTEN": "Actiepunten",
      "KENBRI_ACTIVITEITEN": "Kenbri activiteiten",
      "NOTULEN": "Notulen",
      "PERIODE_OVERZICHT": "Periode overzicht",
      "TITEL": "Activiteiten"
    },
    "BEHEER": {
      "BEHEREN_CONTACTEN": "Beheren contacten",
      "BEHEREN_CONTACTEN_TEMPLATES": "Beheren contact templates",
      "EXTERNE_APPLICATIES": "Externe applicaties",
      "GEBRUIKERS": "Gebruikers",
      "LOGBOEK": "Logboek",
      "OVERZICHT_KLANTEN": "Overzicht klanten",
      "PRESENTER": {
        "TITEL": "Presenter"
      },
      "SEVESO": {
        "CATEGORIEEN": "Categorieën",
        "TITEL": "Seveso",
        "VRAGEN": "Vragen"
      },
      "TITEL": "Beheer"
    },
    "CONFIGURATIE": {
      "AUTORISATIE": "Autorisatie",
      "ROLLEN": "Rollen",
      "TITEL": "Configuratie"
    },
    "CONTACTGEGEVENS": {
      "TITEL": "Contactgegevens"
    },
    "DASHBOARD": "Dashboard",
    "DOCUMENTEN": {
      "ALGEMEEN": "Algemeen",
      "OBJECTEN": "Objecten",
      "RAPPORTAGE": "Rapportage",
      "TITEL": "Documenten"
    },
    "HELP": {
      "FAQ": "FAQ",
      "HANDLEIDINGEN": "Handleidingen",
      "TITEL": "Hulp"
    },
    "INFO": {
      "GEPLANDE_WIJZIGINGEN": "Geplande wijzigingen",
      "NIEUWS": "Nieuws",
      "TITEL": "Info",
      "UW_LICENTIE": "Uw licentie",
      "VERSIE_OVERZICHT": "Versie overzicht"
    },
    "OBJECTEN": {
      "AANGEVRAAGD": "Aangevraagd",
      "EXTERNE_KOPPELINGEN": "Externe koppelingen",
      "OVERZICHT": "Overzicht",
      "TITEL": "Objecten",
      "VERVALLEN": "Vervallen"
    },
    "PLANNING": {
      "TITEL": "Planning"
    },
    "SEVESO": {
      "ACTIEPUNTEN": "Actiepunten",
      "DASHBOARD": "Dashboard",
      "DOCUMENTEN": "Documenten",
      "DOSSIERS": "Dossiers",
      "MODEL": "Model",
      "TITEL": "SEVESO",
      "TRENDS": {
        "LEVENSDUUR": "Levensduur",
        "NUMERIEKE_DATA": "Numerieke data",
        "TITEL": "Trendanalyses",
        "WERKCODES": "Werkcodes"
      }
    },
    "WERKCODE_ANALYSE": {
      "TITEL": "Werkcode analyse"
    }
  },
  "MFA": {
    "SETUP": {
      "BUTTON": {
        "VOLGENDE": "Volgende stap"
      },
      "DANKJEWEL": "Bedankt, meervoudige verificatie is succesvol ingeschakeld!",
      "FOUTMELDING": "Het is niet mogelijk om meervoudige verificatie in te stellen, keer terug naar de login pagina en probeer het opnieuw.",
      "HERSTELCODES_UITLEG": "Kopieer de onderstaande herstelcodes en bewaar ze op een veilige plek. Je kunt ze gebruiken om je account te herstellen als je geen toegang meer hebt tot de authenticatie-app.",
      "INSTRUCTIES": "Het inschakelen van meervoudige verificatie is verplicht om door te kunnen gaan. Scan de QR met je authenticator app (Google Authenticator, Microsoft Authenticator, etc.)",
      "INSTRUCTIE_HANDMATIG": "Of vul deze code handmatig in",
      "ONGELDIGE_CODE": "Ongeldige code. Probeer het opnieuw",
      "TERUGNAARINLOGGEN": "Terug naar inlog pagina",
      "TITLE": "Instellen meervoudige verificatie",
      "VALIDEREN": "Valideren...",
      "VUL_CODE_IN": "Voer de 6-cijferige code uit uw authenticatie-app in."
    }
  },
  "NOTULEN": {
    "DETAIL": {
      "ACTIEPUNTEN": {
        "TITEL": "Gekoppelde actiepunten"
      },
      "AFGESLOTEN": "Afgesloten",
      "BUTTONS": {
        "ANNULEREN": "Annuleren",
        "OPSLAAN": "Opslaan",
        "VERWIJDEREN": "Verwijderen"
      },
      "DATUM_BESPREKING": "Datum bespreking",
      "MELDING": {
        "IS_AFGESLOTEN": "Let op: deze notulen is afgesloten en kan daarom niet meer worden bewerkt.",
        "NIET_GELADEN": "De notulen kan niet worden geladen.",
        "NIET_VRIJGEGEVEN": "De notulen zijn succesvol vrijgegeven",
        "VERPLICHTE_VELDEN_ONTBREKEN": "Niet alle verplichte velden zijn ingevuld",
        "VRIJGEGEVEN": "De notulen zijn niet vrijgegeven",
        "WEER_OPENEN": {
          "TEKST": "Weet je zeker dat je deze notulen weer wilt openen?",
          "TITEL": "Weer openen"
        }
      },
      "NOTULEN": "Notulen",
      "ONDERWERP": "Onderwerp",
      "TERUG": "Terug naar het overzicht",
      "TITEL": "Detail",
      "VOLGNUMMER": "Volgnummer",
      "VRAAG": {
        "VERWIJDEREN": {
          "TEKST": "Weet je zeker dat je dit notulen wilt verwijderen?",
          "TITEL": "Verwijderen?"
        }
      }
    },
    "GRID": {
      "DATUM_BESPREKING": "Datum bespreking",
      "DETAIL": {
        "ACTIEPUNTEN": {
          "GRID": {
            "DATUM_GEREED": "Datum gereed",
            "DATUM_GEWENST": "Datum gewenst",
            "GEREED": "Gereed",
            "OMSCHRIJVING": "Omschrijving",
            "PRIORITEIT": "Prioriteit",
            "RESULTAAT": "Resultaat",
            "SERVICE_APPARATUUR": "Serviceapparatuur nodig",
            "UITVOERENDE": "Uitvoerende",
            "VERANTWOORDELIJKE": "Verantwoordelijke",
            "VERVOLG_ACTIES": "Vervolg acties"
          },
          "TITEL": "Actiepunten"
        }
      },
      "LAATST_GEWIJZIGD": "Laatst gewijzigd",
      "LAATST_GEWIJZIGD_DOOR": "Laatst gewijzigd door",
      "LABEL": {
        "AFGESLOTEN": "Afgesloten",
        "BEWERKEN": "Bewerken",
        "DETAILS_WEERGEVEN": "Details weergeven",
        "VERWIJDEREN": "Verwijderen"
      },
      "NOTULEN": "Notulen",
      "ONDERWERP": "Onderwerp",
      "VOLGNUMMER": "Volgnummer"
    },
    "MELDING": {
      "NIET_OPGESLAGEN": "Het record kan niet worden opgeslagen: {{msg}}",
      "NIET_TOEGEVOEGD": "Het record kan niet worden toegevoegd: {{msg}}",
      "NIET_VERWIJDERD": "Het record kan niet worden verwijderd: {{msg}}",
      "OPGESLAGEN": "Het record is succesvol opgeslagen",
      "TOEGEVOEGD": "Het record is succesvol toegevoegd",
      "VERWIJDERD": "Het record is succesvol verwijderd"
    },
    "TITEL": "Notulen"
  },
  "OBJECTEN": {
    "AANGEVRAAGD": {
      "FABRIKANT": "Fabrikant",
      "INSTALLATIE_DATUM": "Installatiedatum",
      "LOCATIE_OBJECT": "Locatie object",
      "NAAM": "Naam",
      "POPUP": {
        "BUTTON_CANCEL": "Annuleren",
        "BUTTON_SAVE": "Object opslaan",
        "TITEL": "Aanmaken nieuw object"
      },
      "PREVENTIEF_NUMMER": "Preventief nummer",
      "PRODUCTGROEP": "Productgroep",
      "SERVICE": "Service uitvoeren door Kenbri",
      "SUCCESVOL": "Het object is succesvol aangevraagd",
      "TITEL": "Aangevraagde objecten",
      "TYPE": "Type",
      "UW_LOCATIE": "Uw locatie"
    },
    "ACTIEPUNTEN": {
      "GRID": {
        "DATUM_GEWENST": "Datum gewenst",
        "GEBRUIKTE_MATERIALEN": "Gebruikte materialen",
        "GEKOPPELDE_WERKCODES": "Gekoppelde werkcodes",
        "OMSCHRIJVING": "Omschrijving",
        "PRIORITEIT": "Prioriteit",
        "RESULTAAT": "Resultaat",
        "SERVICE_APPARATUUR": "Service apparatuur",
        "UITVOERENDE": "Uitvoerende",
        "VERANTWOORDELIJKE": "Verantwoordelijke",
        "VERVOLG_ACTIES": "Vervolg acties"
      }
    },
    "DETAIL": {
      "AANMAKEN_RAPPORT": "Het rapport met {{objectenAantal}} wordt momenteel opgehaald, bij veel objecten kan dit tot enkele minuten duren...",
      "ACTIVITEIT_RAPPORT_TITEL": "Activiteit rapport - {{titel}}",
      "BEDRIJFSUREN": "Bedrijfsuren",
      "DATUM_GEINSTALLEERD": "Datum geinstalleerd",
      "DOCUMENTEN": {
        "DOWNLOAD_FOUT": "Het bestand kan niet worden gedownload, neem contact op met de beheerder",
        "GRID": {
          "DOCUMENTSOORT": "Documentsoort",
          "DOWNLOADEN": "Document downloaden",
          "NAAM": "Naam",
          "OPMERKINGEN": "Opmerkingen",
          "RAPPORT_FOTO": "Rapport foto"
        },
        "TITEL": "Gekoppelde document"
      },
      "FABRIKANT": "Fabrikant",
      "FABRIKANT_TYPE": "Fabrikant type",
      "FOUT_NIET_GELADEN": "Het object kan niet worden geladen, neem contact op met de beheerder",
      "GEKOPPELDE_ACTIVITEITEN": {
        "GRID": {
          "ACTIVITEIT_WEERGEVEN": "Activiteit weergeven",
          "BEDRIJFSUREN": "Bedrijfsuren",
          "DATUM_GEPLAND": "Datum gepland",
          "DATUM_UITGEVOERD": "Datum uitgevoerd",
          "EERSTE_OBJECT": "Eerste object",
          "HATZGENERATOR": "Hatzgenerator",
          "KENBRI_REFERENTIE": "Kenbri referentie",
          "KILOMETERSTAND": "Kilometerstand",
          "LIJST": "Lijst",
          "OMSCHRIJVING": "Omschrijving",
          "ONZE_REFERENTIE": "Onze referentie",
          "PDF_RAPPORT_GENEREREN_WEERGEVEN": "PDF rapport genereren en weergeven",
          "PDF_RAPPORT_WEERGEVEN": "PDF rapport weergeven",
          "STATUS": "Status",
          "WERKZAAMHEDE": "Werkzaamheden"
        },
        "TITEL": "Gekoppelde kenbri activiteiten"
      },
      "HATZGENERATOR": "Hatzgenerator",
      "JAAR": "Jaar",
      "KILOMETERSTAND": "Kilometerstand",
      "KLANTAFSPRAKEN": {
        "BUTTON_OPSLAAN": "Afspraken opslaan",
        "NIET_OPGESLAGEN": "De afspraken zijn niet opgeslagen, neem contact op met de beheerder",
        "OPGESLAGEN": "De afspraken zijn succesvol opgeslagen",
        "TITEL": "Klantafspraken"
      },
      "LADEN_CLOUD_RAPPORT": "Het pdf rapport wordt opgehaald uit de cloud...",
      "LOCATIE": "Locatie",
      "LOCATIE_DETAILS": "Locatie details",
      "LOGBOEK": {
        "FOUT_LADEN": "Er is is mis fout gegaan, neem contact op met de beheerder",
        "GRID": {
          "DATUM": "Datum",
          "OPMERKINGEN_WERKZAAMHEDEN": "Opmerkingen/Werkzaamheden",
          "UITGEVOERD_DOOR": "Uitgevoerd door"
        },
        "MELDING_AANGEMAAKT": "De mutatie is succesvol aangemaakt",
        "MELDING_GEWIJZIGD": "De mutatie is succesvol gewijzigd",
        "MELDING_VERWIJDERD": "De mutatie is succesvol verwijderd",
        "TITEL": "EIGEN LOG & MUTATIE"
      },
      "NAAM": "Naam",
      "OBJECT_RAPPORT_TITEL": "Object rapport - {{title}}",
      "PREVENTIEF_NUMMER": "Preventief nummer",
      "PRODUCTGROEP": "Productgroep",
      "ROEPNUMMER": "Roepnummer",
      "STATUS": "Status",
      "TITEL": "Detail",
      "VERVALLEN": "Vervallen",
      "WERKCODES": {
        "EXPORT": {
          "BESTANDSNAAM": "Werkcodes"
        },
        "GRID": {
          "JAAR": "Jaar",
          "OPMERKING": "Opmerkingen",
          "STATUS": "Status",
          "WERKCODE": "Werkcode"
        },
        "MELDING": {
          "KAN_NIET_LADEN": "De werkcodes kunnen niet worden geladen, neem contact op met de beheerder"
        },
        "TITEL": "Werkcodes"
      }
    },
    "EXTERNE_LINKS": {
      "AANGEMAAKT": "De externe link is succesvol aangemaakt",
      "FOUT_SELECTEER_OBJECTEN": "Selecteer eerst één of meerdere objecten",
      "FOUT_TEKST": "Er is is mis fout gegaan, neem contact op met de beheerder",
      "FOUT_TITEL": "Fout",
      "GELUKT": "Gelukt",
      "GEWIJZIGD": "De externe link is succesvol gewijzigd",
      "GRID": {
        "APPLICATIE": "Applicatie",
        "DETAIL": {
          "BUTTON_KOPPELEN": "Kopppel geselecteerde objecten",
          "BUTTON_ONTKOPPELEN": "Ontkoppel geselecteerde objecten",
          "GEKOPPELDE_OBJECTEN": "Gekoppelde objecten",
          "OBJECT": "Object",
          "TE_KOPPELEN_OBJECTEN": "Te koppelen objecten"
        },
        "LINK": "Link"
      },
      "KAN_NIET_LADEN": "Kan de externe applicaties niet laden, neem contact op met de beheerder",
      "KOPPELING_GESLAAGD": "De koppeling is succesvol aangemaakt",
      "KOPPELING_VERWIJDERD": "De koppeling is succesvol verwijderd",
      "OPGELET": "Opgelet",
      "TITEL": "Externe koppelingen",
      "VERWIJDERD": "De externe link is succesvol verwijderd"
    },
    "FOUTEN": {
      "KAN_FABRIKANTEN_NIET_LADEN": "De fabrikanten kunnen niet worden geladen",
      "KAN_LOCATIES_NIET_LADEN": "De locaties kunnen niet worden geladen",
      "KAN_OBJECTEN_NIET_LADEN": "De objecten kunnen niet worden geladen",
      "KAN_OBJECT_NIET_AANMAKEN": "Kan het object item niet aanmaken",
      "KAN_PRODUCTGROEPEN_NIET_LADEN": "De productgroepen kunnen niet worden geladen",
      "KAN_TYPES_NIET_LADEN": "De types kunnen niet worden geladen",
      "KAN_UITVOERINGEN_NIET_LADEN": "De uitvoeringen kunnen niet worden geladen",
      "TITEL": "Fout!"
    },
    "OBJECT_AANVRAGEN": "Object aanvragen",
    "OVERZICHT": {
      "GRID": {
        "AANTAL_SUBOBJECTEN": "#Subobjecten",
        "ACTIEPUNTEN_WEERGEVEN": "Actiepunten weergeven",
        "ACTIVITEIT_WEERGEVEN": "Activiteit weergeven",
        "BEDRIJFSUREN": "Bedrijfsuren",
        "CHASSISBOUWER": "Chassis bouwer",
        "CONCEPT": "Concept",
        "DETAILS_WEERGEVEN": "Details weergeven",
        "EXTERNE_LINKS": "Externe links",
        "EXTERNE_LINKS_WEERGEVEN": "Externe links weergeven",
        "FABRIKANT": "Fabrikant",
        "FILTER_WISSEN": "Filter wissen",
        "HATZGENERATOR": "Hatzgenerator",
        "INSPECTIE_LOCATIE": "Inspectie locatie",
        "JAAR": "Jaar",
        "KILOMETERSTAND": "Kilometerstand",
        "KLANT_AFSPRAKEN": "Klantafspraken",
        "KLANT_LOCATIE_WZH": "Klant locatie wzh.",
        "LAATSTE_ACTIVITEIT": "Laatste activiteit",
        "NAAM": "Naam",
        "OPENSTAANDE_ACTIEPUNTEN": "Openstaande actiepunten",
        "OPEN_DETAIL": "Open detail gegevens in een nieuw tabblad:",
        "OPVOLGING": "Opvolging",
        "PREVENTIEF_NUMMER": "Preventief nummer",
        "PRODUCTGROEP": "Productgroep",
        "RAPPORT_WEERGEVEN": "Rapport weergeven",
        "ROEPNUMMER": "Roepnummer",
        "STATUS": "Status",
        "TYPE": "Type",
        "UITVOERING": "Uitvoering",
        "VOLGENDE_ACTIVITEIT": "Volgende activiteit"
      },
      "TITEL": "Objecten overzicht"
    },
    "VERVALLEN": {
      "TITEL": "Vervallen objecten"
    }
  },
  "PLANNING": {
    "DETAIL": {
      "STATUS": "Status"
    },
    "DETAIL_MEDEWERKER": "Medewerker",
    "DETAIL_OBJECT": "Object",
    "DETAIL_OPEN_ACTIVITEIT": "Open activiteit",
    "DETAIL_OPEN_RAPPORT": "Open rapport",
    "DETAIL_ORDERNUMMER": "Ordernummer",
    "DETAIL_REFERENTIE": "Referentie",
    "LEGENDA": {
      "CONCEPT": "Kenbri activiteit",
      "KENBRI": "Kenbri concept activiteit"
    },
    "MELDING": {
      "KAN_NIET_LADEN": "De planning kan niet worden geladen, neem contact op met de beheerder"
    },
    "TITEL": "Planning"
  },
  "RAPPORT": {
    "FOUT": {
      "TEKST": "Er is een fout opgetreden, het rapport kan niet worden geladen. Neem contact op met Kenbri via +31(0)187493588.",
      "TITEL": "Foutmelding"
    },
    "VIEWER": {
      "MELDING": {
        "FOUT": {
          "KAN_RAPPORT_NIET_OPENEN": "Er is een fout opgetreden, het rapport kan niet worden geladen. Neem contact op met Kenbri via +31(0)187493588.",
          "ONGELDIGE_LINK": "De gebruikte link is ongeldig, neem voor vragen contact op met Kenbri via +31(0)187493588.",
          "TITEL": "Foutmelding"
        },
        "LADEN": "Even geduld, het pdf rapport wordt opgehaald uit de cloud...",
        "OPENEN": "Bezig met openen van het document, bij veel objecten kan dit tot enkele minuten duren...."
      },
      "TITEL": "Rapport voor activiteit: {{klantReferentie}}"
    }
  },
  "SEVESO": {
    "ACTIEPUNTEN": {
      "AANGEMAAKTDOOR": "Aangemaakt door",
      "AANGEMAAKTOP": "Aangemaakt op",
      "ALLEDOSSIERS": "Alle dossiers",
      "CATEGORIE": "Categorie",
      "DATUMBESPREKING": "Bespreekdatum",
      "DATUMGEPLAND": "Datum gepland",
      "DATUMGEREED": "Datum gereed",
      "GEENACTIEFDOSSIER": "Er is geen (actief) Seveso dossier",
      "GEREED": "Gereed",
      "JA": "Ja",
      "NEE": "Nee",
      "OMSCHRIJVING": "Omschrijving",
      "POPUPTITEL": "Actiepunt wijzigen",
      "TITLE": "SEVESO Actiepunten",
      "VERANTWOORDELIJKE": "Verantwoordelijke",
      "VRAAG": "Vraag"
    },
    "BUTTON": {
      "INFO": "Info"
    },
    "CONFIGURATION": {
      "DETAIL": {
        "CATEGORIEGEKOPPELD": "Gekoppelde categorieën",
        "GRID": {
          "NUMMER": "Nummer",
          "ONDERWERP": "Onderwerp",
          "VERVALLEN": "Vervallen",
          "VRAAG": "Vraag"
        },
        "SELECTEERCATEGORIE": "Selecteer links een categorie",
        "TITLE": "Beheren dossier {{Omschrijving}}",
        "VRAAGBASISGEGEVENS": "Er zijn nog geen categorieën en vragen gekoppeld, wil je de standaard categorieën en vragen overnemen?",
        "VRAAGBASISGEGEVENSTITEL": "Categorieën en vragen overnemen?",
        "VRAGENGEKOPPELD": "Vragen gekoppeld aan de categorie: {{Naam}}"
      },
      "DOSSIERSUCCESVOLGEDUPLICEERD": "Dossier succesvol gedupliceerd",
      "FOUTDOSSIERNIETTOEGEVOEGD": "Het dossier kan niet worden toegevoegd",
      "FOUTDOSSIERNIETVERWIJDERD": "Het dossier kan niet worden verwijderd, als er categorieën en vragen zijn gekoppeld kan een dossier niet meer verwijderd worden.",
      "FOUTDOSSIERSNIETGELADEN": "De dossiers kunnen niet worden geladen",
      "FOUTDOSSIERSNIETGEWIJZIGD": "Het dossier kan niet worden gewijzigd",
      "GEENCATEGORIEGESELECTEERD": "Weet je zeker dat je geen documenten wilt overnemen?",
      "GRID": {
        "AANTALGEPLANDEINSPECTIES": "#Geplande inspecties",
        "AANTALMELDINGENDCMR": "#DCMR meldingen",
        "AANTALMELDINGENDCMRKENBRIBETROKKEN": "#Kenbri DCMR meldingen",
        "BEGINDATUM": "Begindatum",
        "BUDGETFORECASTCORRECTIEF": "Budget forecast correctief",
        "BUDGETFORECASTPREVENTIEF": "Budget forecast preventief",
        "BUDGETKOSTENHUIDIGJAAR": "Budget kosten huidig jaar",
        "BUDGETKOSTENVOLGENDJAAR": "Budget kosten aankomend jaar",
        "BUDGETKOSTENVOLGENDJAARCORRECTIEF": "Waarvan correctief",
        "EINDDATUM": "Einddatum",
        "ISACTIEFDOSSIER": "Actief dossier",
        "OMSCHRIJVING": "Omschrijving",
        "REALISATIEKOSTENHUIDIGJAAR": "Realisatie kosten huidig jaar",
        "VERVALLEN": "Vervallen",
        "VOLGORDE": "Volgorde"
      },
      "TITELVRAAGDOSSIERDUPLICEREN": "Dossier dupliceren?",
      "TITELVRAAGGEENCATEGORIEGESELECTEERD": "Zeker weten?",
      "TITLE": "Beheren SEVESO dossiers",
      "VERWIJDEREN": {
        "ACTIEF_DOSSIER": "Dit dossier is momenteel actief en kan daarom niet worden verwijderd",
        "GRID": {
          "AANTAL_ACTIEPUNTEN": "Aantal actiepunten",
          "AANTAL_DOCUMENTEN": "Aantal documenten",
          "AANTAL_OPENSTAANDE_ACTIEPUNTEN": "Aantal openstaande actiepunten",
          "AANTAL_VRAGEN": "Aantal vragen",
          "AANTAL_VRAGEN_GECONTROLEERD": "Aantal vragen gecontroleerd",
          "AANTAL_VRAGEN_INGEVULD": "Aantal vragen ingevuld",
          "AANTAL_VRAGEN_MET_RESULTAAT": "Aantal vragen met resultaat",
          "CATEGORIE": "Categorie"
        },
        "POPUP": {
          "INTROTEKST": "<p>Weet u zeker dat u dit Seveso dossier wilt verwijderen? Let op: dit kan niet ongedaan worden gemaakt.</p>\n<p>Hieronder vindt je een overzicht van de gekoppelde gegevens die verwijderd zullen worden</p>",
          "TITEL": "Verwijderen dossier"
        }
      },
      "VRAAGDOSSIERDUPLICEREN": "Weet je zeker dat je dit dossier wilt dupliceren?"
    },
    "COPY": {
      "BUTTONCLOSE": "Annuleren",
      "BUTTONCOPY": "Dupliceren",
      "MESSAGE": "Selecteer de categorieën waarvan de documenten gekopieerd moeten worden naar het nieuwe dossier.",
      "TITLE": "Documenten kopiëren?"
    },
    "DASHBOARD": {
      "AANTAL": "Aantal",
      "AANTALBETROKKENDCMR": "Betrokkenheid Kenbri:",
      "AANTALDCMR": "Aantal DCMR meldingen:",
      "AANTALGECONTROLEERD": "Gecontroleerd",
      "AANTALINGEVOERD": "Ingevuld",
      "AANTALUITGEVOERD": "Uitgevoerd",
      "ALGEMENEINFORMATIE": "Algemeen",
      "BEGINDATUM": "Begindatum:",
      "BUDGETFORECASTCORRECTIEF": "Budget forecast correctief:",
      "BUDGETFORECASTPREVENTIEF": "Budget forecast preventief:",
      "BUDGETKOSTENHUIDIGJAAR": "Budget kosten huidig jaar",
      "BUDGETKOSTENVOLGENDJAAR": "Budget kosten aankomend jaar",
      "BUDGETKOSTENVOLGENDJAARCORRECTIEF": "Waarvan correctief",
      "DETAILS_WEERGEVEN": "Details weergeven",
      "EINDDATUM": "Einddatum",
      "GEENACTIEFDOSSIER": "Er is geen (actief) Seveso dossier",
      "OPENACTIEPUNTEN": "Openstaande actiepunten",
      "REALISATIEKOSTENHUIDIGJAAR": "Realisatie kosten huidig jaar",
      "TITLE": "Dashboard",
      "VOORTGANGDOSSIER": "Voortgang Seveso model",
      "VOORTGANGINSPECTIES": "Voortgang preventieve inspecties"
    },
    "DETAIL": {
      "ACTIEPUNTEN": {
        "TITEL": "Actiepunten"
      },
      "ANWSERBUTTON": "Vraag markeren als ingevuld",
      "ANWSERUNDOBUTTON": "Ingevuld ongedaan maken",
      "BACKBUTTON": "Terug",
      "BUTTONCLOSE": "Sluiten",
      "CHECKBUTTON": "Vraag markeren als gecontroleerd",
      "CHECKUNDOBUTTON": "Gecontroleerd ongedaan maken",
      "DOCUMENTEN": {
        "NIETGEUPLOAD": "Het document kan niet worden geupload, neem contact op met de beheerder",
        "POPUP": {
          "TITEL": "Document wijzigen"
        },
        "SUCCESVOLGEUPLOAD": "Het document is succesvol geupload",
        "TITLE": "Gekoppelde documenten",
        "TOOLTIPBESTANDDOWNLOADEN": "Bestand downloaden"
      },
      "DOCUMENTENGRID": {
        "BESTANDSNAAM": "Bestandsnaam",
        "CATEGORIE": "Categorie",
        "GEUPLOADDOOR": "Toegevoegd door",
        "NAAM": "Naam",
        "OMSCHRIJVING": "Omschrijving",
        "UPLOADDATUM": "Toegevoegd op",
        "VRAAG": "Vraag"
      },
      "GRID": {
        "AANTALACTIEPUNTEN": "#Actiepunten",
        "AANTALDOCUMENTEN": "#Documenten",
        "NUMMER": "Nummer",
        "ONDERWERP": "Onderwerp",
        "VRAAG": "Vraag"
      },
      "LOGS": {
        "DATUMTIJD": "Datum en tijd",
        "DESCRIPTION": "Actie",
        "GEBRUIKERSNAAM": "Gebruikersnaam",
        "TITLE": "Log"
      },
      "RESULTAAT": "Resultaat",
      "RESULTAATNIETOPGESLAGEN": "Het resultaat is niet opgeslagen",
      "RESULTAATSUCCESVOLOPGESLAGEN": "Het resultaat is opgeslagen",
      "RESULTPLACEHOLDER": "Vul hier het resultaat in",
      "SAVEBUTTONCLOSE": "Opslaan & sluiten",
      "SAVEBUTTONNEXT": "Opslaan & volgende",
      "TITELVRAAGGEWIJZIGDOPSLAAN": "Wijzigingen gededecteerd!",
      "TITLE": "Invoer categorie: {{Omschrijving}}",
      "UPLOADBUTTON": "Document(en) uploaden",
      "VAN": "van",
      "VRAAG": "Vraag",
      "VRAAGGEWIJZIGDOPSLAAN": "Het resultaat is gewijzigd, wijzigingen opslaan?",
      "WARNINGRESULTEMPTY": "Er is geen resultaat ingevuld",
      "WARNINGTITLE": "Opgelet!"
    },
    "MODEL": {
      "GEENACTIEFDOSSIER": "Er is geen (actief) Seveso dossier",
      "TITLE": "SEVESO model"
    },
    "TECHNICALERROR": "De gegevens kunnen niet worden geladen, neem contact op met de beheerder",
    "TECHNICALERRORTITLE": "Fout"
  },
  "TRENDS": {
    "ER_ZIJN_GEEN_RESULTATEN": "Er zijn geen resultaten voor {{naam}}, informeer bij uw contactpersoon naar de mogelijkheden.",
    "GEEN_DATA_AANWEZIG": "Er is geen data beschikbaar om trends te tonen,\r\n            informeer bij uw\r\n            contactpersoon naar de mogelijkheden.",
    "GEEN_TRENDS_GECONFIGUREERD": "Er zijn geen trends geconfigureerd, informeer bij uw\r\n            contactpersoonnaar de\r\n            mogelijkheden.",
    "GEGEVENS_TONEN_TOT_EN_MET": "tot en met",
    "GEGEVENS_TONEN_VAN": "gegevens tonen van",
    "GEGEVENS_TONEN_VOOR": "Gegevens tonen voor",
    "LEVENSDUUR": {
      "AANTAL": "Aantal",
      "ALLE_PRODUCTGROEPEN": "Alle productgroepen",
      "GEEN_OBJECTEN": "Er zijn geen objecten gevonden die in aanmerking komen voor dit overzicht",
      "MELDING": {
        "NIET_GELADEN": "Het levensduur overzicht kan niet worden geladen, neem contact op met de beheerder"
      },
      "TITEL": "LEVENSDUUR OBJECTEN"
    },
    "TITEL": "WERKCODE TRENDS",
    "WERKCODES": {
      "AANTAL": "Aantal",
      "ALLE_JAREN": "Alle jaren",
      "ALLE_WERKCODES": {
        "TITEL": "Alle werkcodes"
      },
      "GEMIDDELDE_ALLE_JAREN": "Gemiddelde alle jaren",
      "MELDING": {
        "PER_PRODUCTGROEP_NIET_GELADEN": "De werkcodes per productgroep kunnen niet worden geladen, neem contact op met de beheerder",
        "TOP10_NIET_GELADEN": "De werkcodes top 10 kan niet worden geladen, neem contact op met de beheerder",
        "TOP10_OBJECTEN_NIET_GELADEN": "De objecten top 10 kan niet worden geladen, neem contact op met de beheerder",
        "WERKCODES_NIET_GELADEN": "De werkcodes kunnen niet worden geladen, neem contact op met de beheerder"
      },
      "PRODUCTGROEPEN": {
        "TITEL": "Werkcodes gebaseerd op productgroepen"
      },
      "TITEL": "WERKCODE TRENDS",
      "TOP10_OBJECTEN": {
        "TITEL": "Top 10 objecten met de meeste werkcodes"
      },
      "TOP10_WERKCODES": {
        "TITEL": "Top 10 meest voorkomende werkcodes"
      }
    }
  },
  "TRENNDS": {
    "GEGEVENS_TONEN_VOOR": "GEGEVENS TONEN VOOR"
  },
  "WACHTWOORD_INSTELLEN": {
    "BUTTON_INSTELLEN": "Wachtwoord opnieuw instellen",
    "EMAILADRES": "Emailadres",
    "FOUTMELDING": "Foutmelding",
    "GEBRUIKERSNAAM": "Gebruikersnaam",
    "HERHAAL_NIEUW_WACHTWOORD": "Herlaal nieuw wachtwoord",
    "HINT_TEKST": "Vul je gebruikersnaan, emailadres en je het nieuwe wachtwoord in",
    "MELDING": {
      "EMAILADRES_VERPLICHT": "Emailadres is verplicht",
      "HERHAAL_WACHTWOORD_VERPLICHT": "Nieuw wachtwoord is verplicht",
      "WACHTWOORD_VERPLICHT": "Nieuw wachtwoord is verplicht"
    },
    "MELDING_WACHTWOORDEN_KOMEN_NIET_OVEREEN": "De nieuwe wachtwoorden komen niet overeen",
    "MELDING_WACHTWOORD_AANGEPAST": "Het wachtwoord is succesvol aangepast",
    "NIEUW_WACHTWOORD": "Nieuw wachtwoord",
    "TECHNISCH_PROBLEEM": "Er is een technisch probleem opgetreden, probeer het nogmaals of neem contact op met de beheerder",
    "TITEL": "TotalCare portal - wachtwoord opnieuw instellen"
  },
  "WACHTWOORD_VERGETEN": {
    "BUTTON": {
      "CODE_AANVRAGEN": "Code aanvragen"
    },
    "EMAILADRES": "Emailadres",
    "GEBRUIKERSNAAM": "Gebruikersnaam",
    "MELDING": {
      "EMAILADRES_VERPLICHT": "Emailadres is verplicht",
      "GEBRUIKERSNAAM_VERPLICHT": "Gebruikersnaam is verplicht",
      "OPNIEUW_INGESTELD": "Er is een email verstuurd naar het opgegeven emailadres, volg de instructies in deze email om het wachtwoord opnieuw in te stellen",
      "TECHNISCHE_FOUT": "Er is een technisch probleem opgetreden, probeer het nogmaals of neem contact op met de beheerder",
      "TITEL_OPNIEUW_INGESTELD": "Wachtwoord opnieuw instellen"
    },
    "TEKST_HINT": "Vul je gebruikersnaan en emailadres in om je wachtwoord opnieuw in te stellen",
    "TERUG": "Terug naar inloggen?",
    "TITEL": "TotalCare portal - wachtwoord vergeten?"
  },
  "WACHTWOORD_WIJZIGEN": {
    "ANNULEREN": "Annuleren",
    "HERHAAL_NIEUW_WACHTWOORD": "Herhaal nieuw wachtwoord",
    "HERHAAL_NIEUW_WACHTWOORD_VERPLICHT": "Herhaal wachtwoord is verplicht",
    "HUIDIG_WACHTWOORD": "Huidig wachtwoord",
    "HUIDIG_WACHTWOORD_VERPLICHT": "Huidig wachtwoord is verplicht",
    "NIEUW_WACHTWOORD": "Nieuw wachtwoord",
    "NIEUW_WACHTWOORD_KOMTNIETOVEREEN": "De nieuwe wachtwoorden komen niet overeen",
    "NIEUW_WACHTWOORD_VERPLICHT": "Nieuw wachtwoord is verplicht",
    "SUCCESVOL_TEKST": "Het wachtwoord is succesvol gewijzigd",
    "SUCCESVOL_TITEL": "Wachtwoord gewijzigd",
    "TITEL": "Wachtwoord wijzigen"
  },
  "WERKCODES": {
    "TRENDS": {
      "ACTUELE_ORDERS": "actuele orders",
      "ALLES_WEERGEVEN": "alles weergeven",
      "ALLE_JAREN": "Alle jaren",
      "CIRKELDIAGRAM": "Cirkeldiagram",
      "GEGEVENS_TONEN_VOOR": "Gegevens tonen voor",
      "GRID": {
        "AANTAL": "Aantal",
        "OBJECT": "Object",
        "WERKCODE": "Werkcode"
      },
      "MELDINGEN": {
        "OBJECTEN_NIET_GELADEN": "De objecten top 10 kan niet worden geladen, neem contact op met de beheerder",
        "WERKCODES_NIET_GELADEN": "De werkcodes top 10 kan niet worden geladen, neem contact op met de beheerder"
      },
      "OVERVIEW": {
        "GRID": {
          "EXPORT": {
            "BESTANDSNAAM": "Werkcodes"
          },
          "FABRIKANT": "Fabrikant",
          "FILTER_WISSEN": "Toon alles / filter opnieuw instellen",
          "JAAR": "Jaar",
          "OBJECT": "Object",
          "OMSCHRIJVING": "Omschrijving",
          "OPMERKING_KLANT": "Opmerking klant",
          "ORDERNUMMER": "Ordernummer",
          "PRODUCTGROEP": "Productgroep",
          "TYPE": "Type",
          "WERKCODE": "Werkcode"
        }
      },
      "TABEL": "Tabel",
      "TITEL": "Werkcode trends",
      "TOON_ALS": "Toon trends als",
      "TOP_MEEST_VOORKOMENDE_OBJECTEN": "Top 10 objecten met de meeste werkcodes",
      "TOP_MEEST_VOORKOMENDE_WERKCODES": "Top 10 meest voorkomende werkcodes",
      "VERBERGEN": "Verbergen",
      "WERKCODE_OVERZICHT": "WERKCODE OVERZICHT"
    }
  }
}